import { Form, FormItemProps, Input, InputProps } from "antd";
import { FunctionComponent } from "react";

export type InputFormItemProps = InputProps & FormItemProps & {
    formStyle?: React.CSSProperties;
    testid?: string;
};

export const InputFormItem: FunctionComponent<InputFormItemProps> = ({ name, label, rules, formStyle, required, hidden, testid, ...rest }) => {

    return (
        <Form.Item name={name.split(".")} label={label} rules={rules} style={formStyle} required={required} hidden={hidden} >
            <Input {...rest} {...({ testid: testid ?? name } as any)} />
        </Form.Item>
    );
}